module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Study Pup Reading & Spelling","short_name":"Study Pup Reading & Spelling","start_url":"/","background_color":"#0ea5e9","theme_color":"#0ea5e9","display":"minimal-ui","icon":"src/images/pup.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2293c152406aa408a536807e39e32aca"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
